module.exports = __webpack_public_path__ + "img/10.a077b48f.png";